import React, { useEffect, useState } from "react";
import CesiumJS from "../../page/CesiumJS";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import SideBar from "./SideBar";
import PotreeControl from "../PotreeUtil/PotreeControl";
import ObstacleModal from "../modal/ObstacleModal";

import {
  useLoadingStore,
  usePointStore,
  usePathStore,
  // useUserStore,
  useSavePathStore,
  useAreaGenerateStore,
  useDownloadModalStore,
  useProjectMEditStore,
} from "../../Store/store";
import Loading from "../common/Loading";
import SavePathModal from "../modal/SavePathModal";
import AreaGenerateModal from "../modal/AreaGenerateModal";
import AddAreaModeModal from "../modal/AddAreaModeModal";
import DownloadModal from "../modal/DownloadModal";
import ProjectMEdit from "../modal/ProjectMEdit";
import MenuButton from "./MenuButton";
import SaveAutoPathModal from "../modal/SaveAutoPathModal";
import DownloadAutoModal from "../modal/DownloadAutoModal";
import { postValidateToken } from "../../api/userManagementAPI";

const Main = styled.main`
  overflow-x: hidden; /* 가로만 숨김 */
  overflow-y: hidden;
  position: absolute;
  top: 64px; /* GNB 높이만큼 오프셋 */
  left: 0;
  width: 100%;
  height: calc(100% - 64px);
`;

const MapLayout = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100vh;

  background: radial-gradient(
    circle at center,
    #202720 0%,
    #202720 30%,
    #252525 50%,
    #1c1c1c 100%
  );
`;

export default function Layout() {
  const location = useLocation();
  const { isLoadingViewer } = useLoadingStore();
  const { obstacleModal } = usePathStore();
  const navigate = useNavigate();

  // const { isUserLoggedIn, checkAuthStatus, initializeAuth, logout } =
  //   useUserStore();
  const { isSavePathOpen, isSaveAutoPathOpen } = useSavePathStore();
  const { isAreaGenerateOpen, isAddAreaModeOpen } = useAreaGenerateStore();
  const {
    isOpen: isDownloadModalOpen,
    areaData,
    isOpenAuto: isDownloadAutoModalOpen,
    areaDataAuto,
  } = useDownloadModalStore();
  const { isProjectMEditOpen, setIsProjectMEditOpen } = useProjectMEditStore();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const validateToken = async () => {
      // localStorage에 등록 여부 확인
      const isRegistered = localStorage.getItem("user-platform-registered");

      // 이미 등록되었으면 실행하지 않음
      if (isRegistered === "true") {
        console.log("이미 유저 정보가 등록되어 있습니다.");
        return;
      }
      try {
        const response = await postValidateToken();
        console.log(response);

        // 성공 시 플래그 저장 (한 번만 등록되도록)
        if (response.success || response) {
          localStorage.setItem("user-platform-registered", "true");
        }
      } catch (error) {
        console.error("유저 정보 등록 실패:", error);
      }
    };
    validateToken();
  }, []);

  return (
    <MapLayout className="map-layout">
      <Main className="ui-overlay">
        <div className="main-container">
          <Outlet /> {/* 라우트된 컴포넌트들 */}
        </div>
      </Main>

      {/* 모바일 메뉴 버튼 */}
      {!isMenuOpen && <MenuButton setIsMenuOpen={setIsMenuOpen} />}

      {/* 네비게이션, 검색 등 */}
      <SideBar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />

      {location.pathname.includes("/potree") && <PotreeControl />}

      {obstacleModal && <ObstacleModal />}
      {isLoadingViewer && <Loading />}
      {isSavePathOpen && <SavePathModal />}
      {isSaveAutoPathOpen && <SaveAutoPathModal />}
      {isAreaGenerateOpen && <AreaGenerateModal />}
      {isAddAreaModeOpen && <AddAreaModeModal />}
      {isDownloadModalOpen && <DownloadModal areaData={areaData} />}
      {isDownloadAutoModalOpen && (
        <DownloadAutoModal areaDataAuto={areaDataAuto} />
      )}
      {isProjectMEditOpen && (
        <ProjectMEdit
          isOpen={isProjectMEditOpen}
          onClose={() => setIsProjectMEditOpen(false)}
        />
      )}
    </MapLayout>
  );
}
